import React, { useState, useEffect, useRef } from "react";
import { Grid, Box, CircularProgress } from "@mui/material";
import axios from "../../../network";
import ProductCard from "./ProductCard";
import LottieError from "../../../components/LottieError";

const InventoryList = ({ warehouseId, openSnackBar }) => {
  const [inventoryItems, setInventoryItems] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [page, setPage] = useState(1);
  const [hasMore, setHasMore] = useState(true);
  const loadingRef = useRef(false);
  const prevWarehouseIdRef = useRef(warehouseId);

  const fetchInventoryItems = async (reset = false, newPage = 1) => {
    try {
      setLoading(true);
      const response = await axios.get(
        `inventories/getinventoryforwarehouse/${warehouseId}/1?page=${newPage}&isPagination=${1}&warehouseId=${warehouseId}`
      );
      if (response.data.Inventories.length > 0) {
        setInventoryItems((prevItems) =>
          reset ? response.data.Inventories : [...prevItems, ...response.data.Inventories]
        );
        setHasMore(true);
      } else {
        setHasMore(false);
      }
      setLoading(false);
    } catch (err) {
      console.error("Error fetching data:", err);
      setLoading(false);
      setError(true);
    }
  };

  useEffect(() => {
    fetchInventoryItems(true, 1);
  }, []);

  useEffect(() => {
    if (warehouseId !== prevWarehouseIdRef.current) {
      setPage(1); 
      setInventoryItems([]); 
      setHasMore(true); 
      prevWarehouseIdRef.current = warehouseId;
      fetchInventoryItems(true, 1); 
    }
  }, [warehouseId]);

  useEffect(() => {
    if (page > 1 && hasMore && !loadingRef.current) {
      fetchInventoryItems(false, page); 
    }
  }, [page]);

  useEffect(() => {
    loadingRef.current = loading;
  }, [loading]);

  const handleScroll = (element) => {
   
    if (
      parseInt(element.target.scrollHeight) -
        parseInt(element.target.scrollTop) -
        parseInt(element.target.clientHeight) <=
        2 &&
      parseInt(element.target.scrollHeight) -
        parseInt(element.target.scrollTop) -
        parseInt(element.target.clientHeight) >=
        -1 &&
      !loadingRef.current
    ) {
      setPage((prevPage) => prevPage + 1);
    }
  };

  useEffect(() => {
    window.addEventListener("scroll", handleScroll, true);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  if (error) {
    return <LottieError />;
  }

  return (
    <Box
    style={{
      overflow: "auto",
      paddingBottom: "70px",
    }}
    >
      <Grid container spacing={1}>
        {inventoryItems.map((item) => (
          <ProductCard
            key={item.id}
            item={item}
            setInventoryItems={setInventoryItems}
            openSnackBar={openSnackBar}
          />
        ))}
      </Grid>
      {loading && (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            marginTop: 2,
          }}
        >
          <CircularProgress />
        </Box>
      )}
    </Box>
  );
};

export default InventoryList;
